<div class="modal-box-large">
  <div class="d-flex flex-column justify-content-start">
    <h4>Ricerca Datore/Azienda</h4>
  </div>
  <app-basic-card class="mt-2 mb-2">
    <app-basic-form
      [form]="searchEmployerForm"
      [keys]="searchEmployerFormKeys"
    ></app-basic-form>
    <div class="mt-3">
      <button
        mat-raised-button
        color="primary"
        (click)="searchEmployer()"
        [disabled]="isSearchDisabled"
        class="mr-3"
      >
        RICERCA
      </button>
      <button
        mat-button
        color="secondary"
        (click)="createNewEmployerCode()"
        [disabled]="!chosenEmployer"
      >
        CREA NUOVO CODICE DATORE
      </button>
      <button mat-button color="warn" class="ml-3" (click)="reset()">
        RESET
      </button>
    </div>
  </app-basic-card>
  @if(dataSource.length > 0) {
  <h5 class="mt-3">Lista Datori</h5>
  <app-be-paginated-table
    [dataSource]="dataSource"
    [tableKeys]="tableKeys"
    (changeRequested)="onChangeRequested($event)"
    (itemSelected)="onItemSelected($event)"
  ></app-be-paginated-table>
  } @else if(hasSearched && !dataSource.loadingSubject.value) {
  <div class="mt-4 d-flex text-center flex-column align-items-center">
    <mat-icon
      class="no-results-icon"
      aria-hidden="false"
      aria-label="no-subjects-icon"
      fontIcon="no_accounts"
    ></mat-icon>
    <h4 class="no-docs-text">Nessun Datore trovato</h4>
  </div>
  }
  <div class="d-flex justify-content-end mt-3">
    <button
      mat-raised-button
      color="primary"
      class="mx-3"
      (click)="onConfirmSelection()"
      [disabled]="isEmployerSelectionConfirmDisabled"
    >
      Conferma
    </button>
    <button mat-button color="warn" class="mx-3" (click)="onCancelSelection()">
      Annulla
    </button>
  </div>
</div>
